export default {
  "/contact/index": [
    {
      path: "/contact/ac_cash_detail",
      name: "acCashDetail",
      meta: {
        title: "联系人详情",
        hiddenTag: true,
        matchedPath: "/contact/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/contact/ac_pay_detail",
      name: "acPayDetail",
      meta: {
        title: "联系人详情",
        hiddenTag: true,
        matchedPath: "/contact/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/contact/ac_sametopup_detail",
      name: "acSametopupDetail",
      meta: {
        title: "联系人详情",
        hiddenTag: true,
        matchedPath: "/contact/index",
        visible: "1",
        operate: "0"
      }
    }
  ],
  "/contact/create": [
    {
      path: "/common/result",
      name: "contactResult",
      meta: {
        title: "创建联系人成功",
        hiddenTag: true,
        matchedPath: "/contact/create",
        visible: "1",
        operate: "0"
      }
    }
  ]
};
